import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { AllowedOsUpdatesStoreActions } from './index';

import { AllowedOsUpdate } from './allowed-os-updates.state';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../../../../stores/router/index';

@Injectable()
export class DeviceAllowedOsUpdatesResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly allowedUpdatesStore: Store<AllowedOsUpdate>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((deviceId) => {
        this.allowedUpdatesStore.dispatch(
          AllowedOsUpdatesStoreActions.AllowedOsUpdatesResolverActions.allowedUpdatesRequested({
            deviceId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
